import React from 'react';
import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import ReactLoading from 'react-loading';
import createReactClass from 'create-react-class';
import PureRenderMixin from 'react-addons-pure-render-mixin';

import NavigationActionCreator from 'action_creators/navigation';
import FormControllerProxy from 'lib/form/controller_proxy';
import { countAdultsIn } from 'lib/pricing_utils';
import Guests from 'views/plugins/booking_request/guests';
import Dates from 'views/plugins/booking_request/dates';
import Times from 'views/plugins/booking_request/times';
import Error from 'views/plugins/booking_request/error';
import { BaseballHallOfFameMembershipUpsell } from 'views/ui/dynamic/';
import NoAvailability from 'views/plugins/tours/page/booking_details/no_availability';
import { t } from 'services/translation';
import D13nStore from 'stores/plugins/d13n';
import TourAvailabilityService from 'services/tour_availability';
import TourAvailabilityActionCreator from 'action_creators/tour_availability';

import { Theme } from 'ui_system/theme';
import { LocationSelect } from 'ui_system/select/location/LocationSelect';
import TimezoneWrapper from 'views/plugins/booking_request/timezone_wrapper/TimezoneWrapper';

import { JoinWaitlist } from 'views/plugins/tours/page/booking_details/waitlist/JoinWaitlist';

import CheckoutHeader from '../header';
import Cover from '../cover';
import Submit from '../submit';
import './index.scss';
import { titleize } from 'lib/string_utils';
import { triggerCheckoutStepScroll } from 'views/plugins/checkout/utils/scroll_utils';

const LoadingWrapper = styled.div`
  margin: 65px 0 44px 10px;
`;

const dynamic_components = {
  baseball_hall_of_fame_membership_upsell: BaseballHallOfFameMembershipUpsell,
};

const BookingInitialScreen = createReactClass({
  displayName: 'BookingInitialScreen',
  mixins: [PureRenderMixin, FormControllerProxy],
  propTypes: {
    tour_id: PropTypes.number.isRequired,
    availableDates: PropTypes.object.isRequired,
    availableTimes: PropTypes.object.isRequired,
    initialDatesCount: PropTypes.number.isRequired,
    fields: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired,
    min_people: PropTypes.number.isRequired,
    max_people: PropTypes.number.isRequired,
    hasAddons: PropTypes.bool.isRequired,
    date_picker_type: PropTypes.string.isRequired,
    priceProps: PropTypes.object,
    is_recurrent: PropTypes.bool,
    booking_request_id: PropTypes.string,
    showDates: PropTypes.bool,
    fromSummary: PropTypes.bool,
    origin_url: PropTypes.string,
    unit_types: PropTypes.object,
    has_resource: PropTypes.bool,
    resource_name: PropTypes.string,
    showPersonalSection: PropTypes.bool,
    initial_ticket_quantity: PropTypes.number.isRequired,
    has_ticket_capacity_enabled: PropTypes.bool,
    sold_out_link_text: PropTypes.string,
    capacityErrorCleared: PropTypes.bool,
  },

  getInitialState() {
    return {
      location: null,
      available_datetimes: [],
      capacityError: null,
      capacityErrorJobInProgress: null,
    };
  },

  getDefaultProps() {
    return {
      booking_request_id: null,
      showDates: false,
      fromSummary: false,
      priceProps: {},
      units: [],
    };
  },

  componentDidMount() {
    // Trigger scroll to iframe for mobile booking flow
    triggerCheckoutStepScroll();
    this.loadAvailableDates();
    this._initializeUnitsState();
  },

  componentDidUpdate(prevProps, prevState) {
    const {
      hasAddons,
      fromSummary,
      showPersonalSection,
      shouldCollectGuestInfo,
      errors,
    } = this.props;
    let nextScreen;
    const errorObject = errors.toJS() || {};

    if (this._hasSaved(prevProps)) {
      const addons_before_cutoff_time = this._filterAvailableAddonsProps();
      if (hasAddons && addons_before_cutoff_time.length) {
        nextScreen = 'BookingAddons';
      } else if (fromSummary && shouldCollectGuestInfo) {
        nextScreen = 'GuestInformation';
      } else if (fromSummary) {
        nextScreen = 'CheckoutSummary';
      } else if (!showPersonalSection) {
        nextScreen = 'CheckoutPayment';
      } else {
        nextScreen = 'CheckoutPersonal';
      }

      NavigationActionCreator.transitionTo(
        `Views.Plugins.Checkout.Mobile.Screens.${nextScreen}`,
        {
          fromSummary: fromSummary,
        }
      );
    }

    // This page relies on displaying errors in the form of a global modal
    // in the case of ticket capacity errors, we want to show them under the
    // ticket selection dropdown
    if (!_.isEmpty(errorObject)) {
      const { capacityErrorCleared } = this.props;
      if (!capacityErrorCleared) {
        if (errorObject.hasOwnProperty('ticket-capacity'))
          this.setState({
            capacityError: errorObject['ticket-capacity'],
          });
        if (errorObject.hasOwnProperty('ticket-capacity-job-in-progress'))
          this.setState({
            capacityErrorJobInProgress:
              errorObject['ticket-capacity-job-in-progress'],
          });
      }
    }

    const { capacityErrorCleared } = this.props;
    if (
      capacityErrorCleared &&
      (this.state.capacityError || this.state.capacityErrorJobInProgress)
    ) {
      this.setState({
        capacityError: null,
        capacityErrorJobInProgress: null,
      });
    }
  },

  loadAvailableDates() {
    if (this.props.asynchronous_calendar) {
      TourAvailabilityActionCreator.getAvailableDates(
        this.props.tour_id,
        (res) => {
          this.setState({
            available_datetimes: res.data.available_datetimes,
          });
        }
      );
    }
  },

  _dynamicCheckoutSlug() {
    const dynamicComponent =
      this.props.tour.settings.dynamic_checkout_component;
    if (!!dynamicComponent && !!dynamicComponent.value) {
      const DynamicCheckoutSlug = dynamic_components[dynamicComponent.value];
      const total = parseFloat(this.props.total);
      let numOfAdults = 1;
      if (this.props.units && this.props.units.length > 0) {
        numOfAdults = countAdultsIn(
          this.props.units,
          this.props.unitTypes.items
        );
      }
      return !!DynamicCheckoutSlug && total > 1 ? (
        <DynamicCheckoutSlug numOfAdults={numOfAdults} total={total} />
      ) : null;
    }
    return null;
  },

  _hasSaved(prevProps) {
    return this.props.saved === true && prevProps.saved === false;
  },

  _gracefulFetchUnits() {
    if (this.props.units && this.props.units.length > 0) {
      return this.props.units;
    } else if (this.state) {
      return this.state.units;
    }

    return [[]];
  },

  _guestsProps() {
    const {
      min_people: minPeople,
      max_people: maxPeople,
      unitTypes,
      unitPrices,
      isAffiliate,
      initial_ticket_quantity: initialTicketQuantity,
      has_ticket_capacity_enabled: hasTicketCapacityEnabled,
      slotTicketCapacities,
      timeSelected,
      tourTicketCapacities,
      tour,
    } = this.props;
    const { online } = tour;
    return {
      minPeople: minPeople,
      maxPeople: maxPeople,
      unitTypes: unitTypes,
      unitPrices: unitPrices,
      value: this._gracefulFetchUnits(),
      renderToolTip: true,
      online: online,
      is_affiliate: isAffiliate,
      initialTicketQuantity: initialTicketQuantity,
      hasTicketCapacityEnabled: hasTicketCapacityEnabled,
      slotTicketCapacities: slotTicketCapacities,
      timeSelected: timeSelected,
      tourTicketCapacities: tourTicketCapacities,
    };
  },

  _initializeUnitsState() {
    this.setState({
      units: this._initialUnits(),
    });
    this.props.onChange('location_id', null);
  },

  _initialUnits() {
    const unitType = this.props.unitTypes.items[0];
    return [
      {
        id: unitType.id,
        count: this.props.initial_ticket_quantity,
      },
    ];
  },

  _dateProps() {
    return {
      multiple_locations: this.props.tour.multiple_locations,
      tourId: this.props.tour_id,
      availableDates: this.props.availableDates,
      initialDatesCount: this.props.initialDatesCount,
      datepickerType: this.props.date_picker_type,
      showDates: this.props.showDates,
      weekStartDay: this.props.weekStartDay,
      location: this.state.location,
      hasTicketCapacityEnabled: this.props.has_ticket_capacity_enabled,
    };
  },

  _timesProps() {
    const newUnits = this.props.fields.toJS().units;
    const guestCount = newUnits.reduce((a, b) => a + b.count, 0);

    return {
      times: this.props.availableTimes,
      datesAvailable: !this._noAvailableDates(),
      dateSelected: !!this.props.fields.get('date'),
      showPlacesLeft: this.props.showPlacesLeft,
      guests: guestCount,
      isoTime: this.props.isoTime,
      loadingDates: this.props.loadingDates,
      hasTicketCapacityEnabled: this.props.has_ticket_capacity_enabled,
    };
  },

  _noAvailableDates() {
    const {
      tour: { multiple_locations },
      loadingDates,
      availableDates,
    } = this.props;

    const noDates = !Object.keys(availableDates).length;

    return (
      (noDates && !multiple_locations) ||
      (noDates && multiple_locations && !loadingDates)
    );
  },

  _errorProps() {
    let message = 'Sorry, no dates available';
    const totalGuests = this.props.fields
      .get('units')
      .reduce((accumulator, unit) => accumulator + unit.count, 0);
    if (totalGuests > 1) {
      message += ` for ${totalGuests} ${D13nStore.d('guest')}s`;
    }
    message += '.';
    return {
      message,
    };
  },

  _coverProps() {
    return {
      forInvoice: this.props.forInvoice,
      tourPicture: this.props.tour.picture,
      guideAvatar: this.props.tour.guide_avatar,
      tourName: this.props.tour.name_translation,
      guideName: this.props.tour.guide_name,
      hasResource: this.props.has_resource,
      resourceName: this.props.resource_name,
    };
  },

  setLocation(location) {
    const locationId = location.value.id;
    this.props.onChange('location_id', locationId);
    this.setState({ location });
    this.props.loadAPIDates(this.props.tour_id, locationId);
  },

  clearTime() {
    this.props.clearTime();
  },

  _shouldRenderError() {
    return (
      this._noAvailableDates() &&
      this.props.initialDatesCount > 0 &&
      !this.props._tooManyGuests()
    );
  },

  _filterAvailableAddonsProps() {
    const tourTimezone = this.props.tour.tour_timezone;
    const date = this._formProps('date').value;
    const time = this._formProps('time').value;
    const tour_slot = `${date} ${time}`;
    return this.props.addons.filter((addon) => {
      return moment
        .tz(tour_slot, 'YYYY-MM-DD h:mma', tourTimezone)
        .isSameOrAfter(addon.earliest_time_available);
    });
  },

  renderLocationSelect() {
    return (
      <div className="field">
        <label>{titleize(t('STORE'))}</label>
        <LocationSelect
          value={this.state.location}
          setValue={this.setLocation}
          userId={this.props.tour.guide_id}
          tourId={this.props.tour_id}
          pluginSlug={this.props.pluginSlug}
        />
      </div>
    );
  },

  renderDates() {
    if (this.props.loadingDates) {
      return (
        <LoadingWrapper>
          <ReactLoading
            type={'spin'}
            delay={0}
            height={40}
            width={40}
            color={Theme.colors.lightBorder}
          />
        </LoadingWrapper>
      );
    } else if (this.noLocation()) {
      return null;
    }
    return (
      <Dates
        {...this._formProps('date', this._dateProps())}
        disabled={this._noAvailableDates() || this.props._tooManyGuests()}
      />
    );
  },

  noLocation() {
    return this.props.tour.multiple_locations && !this.state.location;
  },

  noUnitPrices() {
    return (
      this.props.unitPrices === undefined ||
      this.props.unitPrices.items === undefined
    );
  },

  _getAvailableTimes() {
    if (this.props.asynchronous_calendar) {
      return [...this.state.available_datetimes];
    } else {
      return [...this.props.availableDatetimes];
    }
  },

  render() {
    const {
      tour_id,
      waitlistDetails,
      tour,
      origin_url,
      priceProps,
      onSubmit,
      sold_out_link_text,
    } = this.props;
    const { capacityError, capacityErrorJobInProgress } = this.state;
    const { has_available_waitlist_slots, enabled_for_tour, enabled_for_user } =
      waitlistDetails || {};
    const showWaitlistContent =
      has_available_waitlist_slots && enabled_for_tour && enabled_for_user;
    return (
      <div className="BookingDetailsScreen">
        <CheckoutHeader priceProps={priceProps} backHref={origin_url} />
        <article className="transition-ctx">
          <Cover {...this._coverProps()} />
          <div className="BookingRequest-form ui form">
            {tour.multiple_locations && this.renderLocationSelect()}
            <Guests
              {...this._formProps('units', this._guestsProps())}
              capacityError={capacityError}
              capacityErrorJobInProgress={capacityErrorJobInProgress}
            />
            <TimezoneWrapper
              tourTimezone={this.props.tour.tour_timezone}
              enabled={this.props.tour.online}
              availableDatetimes={this._getAvailableTimes()}
              dateValue={this._formProps('date').value}
              timeValue={this._formProps('time').value}
              setDateTime={this.props.setDateTime}
              clearTime={this.clearTime}
              setGuestTimezone={this.props.setGuestTimezone}
            >
              {this.renderDates()}
              {this._shouldRenderError() && !showWaitlistContent && (
                <Error {...this._errorProps()} />
              )}

              {this.noLocation() || this.props._tooManyGuests() ? null : (
                <Times
                  {...this._formProps('time', this._timesProps())}
                  disabled={this._noAvailableDates()}
                />
              )}
            </TimezoneWrapper>

            {this._dynamicCheckoutSlug()}

            <Submit
              dataTestProp="continue-mobile-booking"
              label={t(tour.settings.continue_booking_label.value)}
              onSubmit={!this._noAvailableDates() && onSubmit}
              disabled={
                this._noAvailableDates() ||
                this.props._tooManyGuests() ||
                this.props.loadingDates ||
                this.noLocation() ||
                this.noUnitPrices()
              }
            />

            {!showWaitlistContent &&
              this._noAvailableDates() &&
              !this.props._tooManyGuests() && (
                <NoAvailability
                  sold_out_link={tour.sold_out_link}
                  sold_out_link_text={tour.sold_out_link_text}
                />
              )}
            {showWaitlistContent && (
              <JoinWaitlist
                experienceId={tour_id}
                noAvailability={
                  this._noAvailableDates() && !this.props._tooManyGuests()
                }
                userId={tour.guide_id}
                soldOutLinkText={sold_out_link_text}
                brandColor={tour.brand_color}
                isoTime={this.props.isoTime}
              />
            )}
          </div>
        </article>
      </div>
    );
  },
});

export default BookingInitialScreen;
